import {createAsyncThunk} from '@reduxjs/toolkit';
import type {CancelSurveyReasonIDs, PauseIntervals} from '@Libraries/cancel-subscription-library';

export const initCancelSubscriptionPanel = createAsyncThunk('initCancelSubscriptionPanel', async () => {
  return window.PMW.readLocal('premium/cancelSubscriptionDialog');
});

export const cancelSubscription = createAsyncThunk('cancelSubscription', async ({reason, comments}: {reason: CancelSurveyReasonIDs; comments: string}) => {
  return window.PMW.writeLocal('premium/cancelSubscription', {
    reason: reason,
    comments: comments,
  });
});

export const pauseSubscription = createAsyncThunk('pauseSubscription', async ({interval}: {interval: PauseIntervals}) => {
  return window.PMW.writeLocal('premium/pauseSubscription', {interval: interval});
});
